(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jouleveil-launch"] && !Shopify.designMode) return;
  try {
    
function setupJouleveil(root) {
  if (!root || root.dataset.jvReady) return;
  root.dataset.jvReady = 'true';
  const design = root.querySelector('#JvDesign');
  const size = root.querySelector('#JvSize');
  const form = root.querySelector('#JouleveilInterest');
  const tags = root.querySelector('[data-jv-tags]');
  if (!design || !size || !form || !tags) return;
  const clean = value => String(value || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 50);
  const source = clean(new URLSearchParams(location.search).get('utm_source') || 'direct');
  const campaign = clean(new URLSearchParams(location.search).get('utm_campaign') || 'first-drop');
  function sync() {
    root.querySelectorAll('[data-design]').forEach(button => {
      const selected = button.dataset.design === design.value;
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', String(selected));
      button.querySelector('.selection-mark').textContent = selected ? '✓' : '';
    });
    tags.value = ['newsletter', 'prospect', 'jv-prelaunch', 'jv-design-' + clean(design.value), 'jv-size-' + clean(size.value), 'jv-source-' + source, 'jv-campaign-' + campaign].join(',');
  }
  root.querySelectorAll('[data-design]').forEach(button => button.addEventListener('click', () => { design.value = button.dataset.design; sync(); }));
  design.addEventListener('change', sync);
  size.addEventListener('change', sync);
  form.addEventListener('submit', sync);
  sync();
}
document.querySelectorAll('[data-jv-launch]').forEach(setupJouleveil);
document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-jv-launch]').forEach(setupJouleveil); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
